var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"psHomeIndicators"},[_c('ps-upper-bar',{attrs:{"site":{ site: 'Home' }}}),_c('div',{staticClass:"container"},[_c('ps-home-decrease-in-patients'),_c('ps-home-subscriptions'),_c('ps-home-groups-in-phase'),_c('ps-home-invoiced')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }